import type { PropsWithChildren } from "react"

import { Backdrop } from "@be-miniapp/ui/components/backdrop"

interface SheetProps extends PropsWithChildren {
  visible: boolean
  mask?: boolean
  maskClosable?: boolean
  autoHeight?: boolean
  height?: number | string
  onClose: () => void
}

const Sheet = ({
  visible,
  mask = true,
  maskClosable = true,
  onClose,
  children,
  autoHeight = true,
  height,
}: SheetProps) => {
  if (!visible) {
    return null
  }

  return (
    <div className="fixed inset-0 z-[10001]">
      <div className="relative size-full">
        {mask ? (
          <Backdrop
            className="absolute inset-0"
            onBackdropClick={() => {
              if (maskClosable) {
                onClose()
              }
            }}
          />
        ) : null}

        <div
          className="absolute inset-x-0 bottom-0 z-[200] flex max-h-[80vh] w-full animate-slide-up-full overflow-hidden rounded-t-lg bg-white pb-safe-bottom shadow-pane"
          style={{
            height: autoHeight && !height ? "auto" : height,
          }}
        >
          <div className="w-full">{children}</div>
        </div>
      </div>
    </div>
  )
}

export { Sheet }
